// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FaRegCalendarAlt } from "react-icons/fa";

// function SubAdminSales() {
//   const [filter, setFilter] = useState("All");
//   const [productData, setProductData] = useState([
//     {
//       id: "ORD001",
//       name: "Product A",
//       order_date: "2024-02-25",
//       invoice_no: "INV001",
//       delivery_date: "2024-03-01",
//       place: "New York",
//       total_amount: "$100",
//       seller_comment: "Fast Delivery",
//       status: "Pending",
//     },
//     {
//       id: "ORD002",
//       name: "Product B",
//       order_date: "2024-02-26",
//       invoice_no: "INV002",
//       delivery_date: "2024-03-02",
//       place: "Los Angeles",
//       total_amount: "$200",
//       seller_comment: "Delayed Due to Weather",
//       status: "Approved",
//     },
//     {
//       id: "ORD003",
//       name: "Product C",
//       order_date: "2024-02-27",
//       invoice_no: "INV003",
//       delivery_date: "2024-03-03",
//       place: "Chicago",
//       total_amount: "$150",
//       seller_comment: "Out of Stock",
//       status: "Rejected",
//     },
//   ]);

//   return (
//     <div>
//       {/* Main content */}
//       <div className="flex flex-col my-5 gap-8 lg:flex-row">
//         <h1 className="text-2xl font-bold mb-4 text-center">Sales</h1>

//         <div className="flex-1">
//           <div className="">
//             <div className="rounded-xl text-sm ">
//               <div className="overflow-x-auto">
//                 {/* Table Header */}
//                 <div className="w-full space-y-4">
//                   <div className="grid grid-cols-[1fr,2.5fr,2fr,2fr,2fr,2fr,2fr,2.5fr,2fr,1.5fr] font-medium text-brand-button-green-bg">
//                     <div className="text-center">No</div>
//                     <div className="text-center">Order Date</div>
//                     <div className="text-center">Order No</div>
//                     <div className="text-center">Invoice No</div>
//                     <div className="text-center">Delivery Date</div>
//                     <div className="text-center">Place</div>
//                     <div className="text-center">Total Amount</div>
//                     <div className="text-center">Seller Comment</div>
//                     <div className="text-center">Status</div>
//                     <div className="text-center">Actions</div>
//                   </div>
//                 </div>
//                 {productData
//                   .filter((product) => {
//                     if (filter === "All") return true;
//                     return product.status === filter;
//                   })
//                   .map((product, index) => (
//                     <div
//                       key={index}
//                       className="grid text-[#2F2E41] min-w-[1024px] grid-cols-[1fr,2.5fr,2fr,2fr,2fr,2fr,2fr,2.5fr,2fr,1.5fr] items-center gap-4 py-2"
//                     >
//                       <div className="border rounded-xl p-2 text-center">{index + 1}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.order_date}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.id}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.invoice_no}</div>
//                       <div className="border p-2 rounded-xl text-center flex items-center justify-center gap-2">
//                         {new Date(product.delivery_date).toLocaleDateString('en-GB')} <FaRegCalendarAlt />
//                       </div>
//                       <div className="border p-2 rounded-xl text-center">{product.place}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.total_amount}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.seller_comment}</div>
//                       <div className="border p-2 rounded-xl text-center">{product.status}</div>
//                       <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
//                         <Link to={`/subadmin/sales/view/`}>View</Link>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SubAdminSales;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaRegCalendarAlt } from "react-icons/fa";
import { USER_URL } from "../../constant/api";
import { BsBoxSeam } from "react-icons/bs";
import Loader from "../../components/Loader/Loader";

function SubAdminSales() {
  const [sales, setSales] = useState([]); // Stores original data
  const [filteredSales, setFilteredSales] = useState([]); // Stores filtered data
  const [isLoading, setIsLoading] = useState(true); // Loading state

  
  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await USER_URL.get("/orders/subadmin/sales/");
        if (response.data.Status === "1") {
          setSales(response.data.Data);
          setFilteredSales(response.data.Data);
        }
      } catch (error) {
        console.error("Error fetching sales data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSales();
  }, []);

  return (
    <div>
      <div className="max-w-md mt-5">
        <h1 className="text-2xl font-medium text-green-600 ">Sales</h1>
      </div>
      <div className="overflow-x-auto mt-5">
        {isLoading ? (
          <Loader />
        ) : filteredSales.length === 0 ? (
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No sales available</p>
          </div>
        ) : (
          <>
            <div className="min-w-[800px] grid grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
              <div className="text-center">Customer Name</div>
              <div className="text-center">Order No</div>
              <div className="text-center">Time</div>
              <div className="text-center">Date</div>
              <div className="text-center">Place</div>
              <div className="text-center">Quantity</div>
              <div className="text-center">Status</div>
              <div className="text-center">Total amount</div>
            </div>
            {filteredSales.map((sale) => (
              <div key={sale.order_number} className="grid text-[#2F2E41] min-w-[800px] grid-cols-[2fr,1fr,1fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2">
                <div className="line-clamp-1 rounded-xl border p-2 text-center">{sale.customer_name}</div>
                <div className="border p-2 rounded-xl text-center line-clamp-1 hover:line-clamp-none">{sale.order_number}</div>
                <div className="border p-2 rounded-xl text-center">{sale.time}</div>
                <div className="border p-2 rounded-xl text-center">{sale.date}</div>
                <div className="border p-2 rounded-xl text-center">{sale.place}</div>
                <div className="border p-2 rounded-xl text-center">{sale.quantity}</div>
                <div className="border p-2 rounded-xl text-center">Delivered({sale.status})</div>
                <div className="border p-2 rounded-xl text-center">{sale.total_amount}</div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}


export default SubAdminSales;

